import { useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { RESULTS_LIMIT_MAINTENANCE_WORK_ORDER } from "@/constants/resultsLimits";
import { MaintenanceWorkOrder } from "@/models/MaintenanceWorkOrder";

export function useMaintenanceWorkOrder() {
  const { geotabClient, activeSessionId } = useGeotabClient();

  return useQuery<MaintenanceWorkOrder[]>({
    queryKey: ["maintenanceWorkOrder", activeSessionId],

    queryFn: ({ signal }) => {
      return geotabClient.call(
        "Get",
        {
          typeName: "MaintenanceWorkOrder",
          search: {
            deviceSearch: {
              fromDate: new Date(),
            },
          },
          resultsLimit: RESULTS_LIMIT_MAINTENANCE_WORK_ORDER,
        },
        signal,
        // API returns data already populated (User, Device, etc. already filled)
      ) as unknown as Promise<MaintenanceWorkOrder[]>;
    },

    refetchInterval: 30000,
  });
}
